// eslint-disable-next-line jira/export/no-external-exports
export { default } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/fields/header/advanced-fields-menu';
